export default {"src":"/_next/static/media/Oops.bb40318e.svg","height":145,"width":322};